/**
 * DevExtreme (esm/__internal/grids/grid_core/columns_controller/const.js)
 * Version: 23.2.10
 * Build date: Mon Oct 28 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var USER_STATE_FIELD_NAMES_15_1 = ["filterValues", "filterType", "fixed", "fixedPosition"];
export var USER_STATE_FIELD_NAMES = ["visibleIndex", "dataField", "name", "dataType", "width", "visible", "sortOrder", "lastSortOrder", "sortIndex", "groupIndex", "filterValue", "bufferedFilterValue", "selectedFilterOperation", "bufferedSelectedFilterOperation", "added"].concat(USER_STATE_FIELD_NAMES_15_1);
export var IGNORE_COLUMN_OPTION_NAMES = {
    visibleWidth: true,
    bestFitWidth: true,
    bufferedFilterValue: true
};
export var COMMAND_EXPAND_CLASS = "dx-command-expand";
export var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
export var GROUP_COMMAND_COLUMN_NAME = "groupExpand";
export var DETAIL_COMMAND_COLUMN_NAME = "detailExpand";
export var COLUMN_OPTION_REGEXP = /columns\[(\d+)\]\.?/gi;
export var DEFAULT_COLUMN_OPTIONS = {
    visible: true,
    showInColumnChooser: true
};
export var DATATYPE_OPERATIONS = {
    number: ["=", "<>", "<", ">", "<=", ">=", "between"],
    string: ["contains", "notcontains", "startswith", "endswith", "=", "<>"],
    date: ["=", "<>", "<", ">", "<=", ">=", "between"],
    datetime: ["=", "<>", "<", ">", "<=", ">=", "between"]
};
export var COLUMN_INDEX_OPTIONS = {
    visibleIndex: true,
    groupIndex: true,
    grouped: true,
    sortIndex: true,
    sortOrder: true
};
export var GROUP_LOCATION = "group";
export var COLUMN_CHOOSER_LOCATION = "columnChooser";
